import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import SectionHeader from "@/components/layout/SectionHeader";
import { ArrowRight, Clock } from "lucide-react";

export function BlogCard({ post, large = false }) {
  return (
    <Link
      to={`/blog/${post.slug}`}
      data-testid={`blog-card-${post.slug}`}
      className={`group block bg-white rounded-2xl border border-slate-200 overflow-hidden card-hover ${large ? "" : ""}`}
    >
      <div className={`relative ${large ? "h-72" : "h-48"} overflow-hidden`}>
        <img src={post.image} alt={post.title} className="w-full h-full object-cover img-zoom" loading="lazy" />
        <span className="absolute top-3 left-3 px-2.5 py-1 text-[10px] uppercase tracking-widest font-bold rounded bg-white/95 text-brand">
          {post.category}
        </span>
      </div>
      <div className={`p-5 ${large ? "md:p-7" : ""}`}>
        <h3 className={`font-montserrat font-bold text-slate-900 leading-snug ${large ? "text-2xl" : "text-base"}`}>
          {post.title}
        </h3>
        <p className="mt-2 text-sm text-slate-600 line-clamp-2">{post.excerpt}</p>
        <div className="mt-3 flex items-center justify-between">
          <div className="text-xs text-slate-500">
            By {post.author}
          </div>
          <div className="text-xs text-slate-500 inline-flex items-center gap-1"><Clock size={12} /> {post.read_time}</div>
        </div>
      </div>
    </Link>
  );
}

export default function BlogTeasers() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then(({ data }) => setPosts(data)).catch(() => {}); }, []);
  if (!posts.length) return null;

  return (
    <section data-testid="blog-teasers" className="container-page py-16 md:py-24">
      <SectionHeader
        kicker="From the Blog"
        title="Travel tips, guides and inspiration"
        subtitle="Long-form destination guides, visa playbooks and honest reviews — written by people who've been there."
        cta={
          <Link to="/blog" data-testid="see-all-blog" className="text-sm font-semibold text-brand hover:underline inline-flex items-center gap-1 ml-auto">
            Read all articles <ArrowRight size={14} />
          </Link>
        }
      />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        <div className="lg:col-span-1">
          <BlogCard post={posts[0]} large />
        </div>
        <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {posts.slice(1, 5).map((p) => <BlogCard key={p.slug} post={p} />)}
        </div>
      </div>
    </section>
  );
}
